import Cache from "./Cache";
import Storage from "./Storage";
export function checkLocalStorage() {
    try {
        localStorage.setItem("localStorageTest", "localStorageTest");
        localStorage.removeItem("localStorageTest");
        return true;
    }
    catch (e) {
        return false;
    }
}
var storages = [];
export var storageInfo = {
    Cache: new Cache("localStorage"),
    hasLocalStorage: checkLocalStorage(),
    broken: false
};
export function promoteMainWindow() {
    window.top.whispeerGetStorage = function (prefix) {
        return this.storages[prefix];
    };
}
export function withPrefix(prefix) {
    if (!storages[prefix]) {
        try {
            storages[prefix] = new Storage(prefix);
        }
        catch (e) {
            storageInfo.broken = true;
        }
    }
    return storages[prefix];
}



//////////////////
// WEBPACK FOOTER
// ./js/services/storage.service.ts
// module id = null
// module chunks = 